
import { useState,createContext, useEffect } from "react";

//create function with parameters in it


const UserContext = createContext();
// const [assets, setAssets] = useState("");





const UserProvider = ({ children }) => {
    const { default: DefaultRedeemAssets } = import("./DefaultAssets.js");
    const [assets, setAssets] = useState(DefaultRedeemAssets); // Set a default value

    // useEffect(() => {
    //     setAssets(isoemps ? OemRedeemAssets : DefaultRedeemAssets);
    // }, []);
    useEffect(() => {
        console.log("channel from redeemjs>>>",sessionStorage.getItem('channel'))
        let isoemps = sessionStorage.getItem("channel") === "OEMAPS1"
        const loadAssets = async () => {
            try {
                if (isoemps) {
                    const { default: OemRedeemAssets } = await import("./OEMAssets.js");
                    setAssets(OemRedeemAssets);
                } else {
                    const { default: DefaultRedeemAssets } = await import("./DefaultAssets.js");
                    setAssets(DefaultRedeemAssets);
                }
            } catch (error) {
                console.error("Error loading assets:", error);
            }
        };

        loadAssets();
    }, [sessionStorage.getItem('channel')]);

    return (
        <UserContext.Provider value={{ assets }}>
            {children}
            {console.log(assets, " are assets")}
        </UserContext.Provider>
    );
};

export { UserContext, UserProvider };
